import { create } from 'zustand'

type CanvasContextMenuTarget =
  | { kind: 'canvas' }
  | { kind: 'shape'; shapeId: string }
  | null

type CanvasContextMenuState = {
  open: boolean
  // Screen coordinates for positioning the menu
  screenX: number
  screenY: number
  // Local coordinates within the Konva stage container
  localX: number
  localY: number
  // Diagram coordinates considering stage scale/offset
  diagramX: number
  diagramY: number
  target: CanvasContextMenuTarget
  openAt: (coords: {
    screenX: number
    screenY: number
    localX: number
    localY: number
    diagramX: number
    diagramY: number
    target?: CanvasContextMenuTarget
  }) => void
  close: () => void
}

export const useCanvasContextMenu = create<CanvasContextMenuState>((set) => ({
  open: false,
  screenX: 0,
  screenY: 0,
  localX: 0,
  localY: 0,
  diagramX: 0,
  diagramY: 0,
  target: { kind: 'canvas' },
  openAt: ({ screenX, screenY, localX, localY, diagramX, diagramY, target }) =>
    set({ open: true, screenX, screenY, localX, localY, diagramX, diagramY, target: target ?? { kind: 'canvas' } }),
  close: () => set({ open: false })
}));
